import React from 'react';
import ReactDOM from 'react-dom';


/* Function
const App = () => {
    window.navigator.geolocation.getCurrentPosition(
        (position) => console.log(position),
        (err) => console.log(err)
    );

    return <div>Latitude: </div>;
};
*/

// class and state
class App extends React.Component {
    // we have to do this everytime when define a construction in a class base
    // intialize state using the constructor js script, which is not required in react
    constructor(props) {
        //super is reference to parent React.Component constructor function
        super(props);  

        // This is the only time we do direct assignment to this.state
        this.state = { lat: null, errorMessage: '' };

        window.navigator.geolocation.getCurrentPosition(
            position => {
                // we called setstate this way!!!!
                this.setState({ lat: position.coords.latitude });

                //  do not do it this way!!!!
                // this.state.lat = position.coords.latitude
            },
            err => {
                this.setState({ errorMessage: err.message });
            }
        );
    }

    // react says we have to define render!!!  Render is required!!!
    render() {

        if (this.state.errorMessage && !this.state.lat)  {
            return <div>Error:  {this.state.errorMessage}</div>;
        }

        if (!this.state.errorMessage && this.state.lat)  {
            return <div>Latitude:  {this.state.lat}</div>;
            }

        return <div>Loading!</div>;

    } 
}

ReactDOM.render(<App />, document.querySelector('#root')); 